import React from "react";

import { useCancel } from "context/cancelContext";
import ReservationForm from "components/ReservationForm";

function Table() {
  const {
    reservation,
    onCancelReservation,
    setShowForm,
    setReservation,
    handleEditItem,
  } = useCancel();

  const onCancel = () => {
    setReservation(null);
    setShowForm(true);
  };

  return (
    <ReservationForm
      reservation={reservation}
      onCancel={onCancel}
      onSave={onCancelReservation}
      onEditItem={handleEditItem}
      cancel
    />
  );
}

export default Table;
